import axios from 'axios';
import { API } from './api';

export const listYears = () => axios.get(`${API}/years/`);

export default listYears;
